import React from 'react'
import styled from 'styled-components'
import { Map, GoogleApiWrapper } from 'google-maps-react'

const GoogleMaps = ({ google }) => {
  return (
    <Wrapper>
      <Map
        containerStyle={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
        style={{ position: 'relative', width: '100%', height: '100%' }}
        google={google}
        zoom={14}
      />
    </Wrapper>
  )
}

export default GoogleApiWrapper({
  apiKey: process.env.YOUR_GOOGLE_API_KEY_GOES_HERE,
})(GoogleMaps)

const Wrapper = styled.div`
  width: 100%;
  height: 67vh;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
